"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Gem, Layers, Zap } from "lucide-react";
import { TechCard } from "@/components/rendering/TechCard";

export default function RenderingPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-6xl w-full">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Drei 材质渲染展示
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            基于 @react-three/drei 成熟材质库，展示现代化的 3D 渲染效果
          </p>
        </div>

        {/* 技术卡片网格 */}
        <div className="grid gap-8 md:grid-cols-3 max-w-5xl mx-auto">
          {/* MeshRefractionMaterial 钻石折射 */}
          <TechCard
            title="钻石折射效果"
            description="使用 MeshRefractionMaterial 材质，结合 CubeCamera 和 Caustics 组件展示钻石折射效果"
            badge={{
              text: "MeshRefractionMaterial",
              variant: "secondary"
            }}
            icon={{
              Icon: Gem,
              bgColor: "bg-blue-100 dark:bg-blue-900/20",
              iconColor: "text-blue-600 dark:text-blue-400"
            }}
            features={[
              { text: "MeshRefractionMaterial 材质", dotColor: "bg-green-500" },
              { text: "CubeCamera 环境映射", dotColor: "bg-green-500" },
              { text: "Caustics 焦散组件", dotColor: "bg-green-500" },
              { text: "Bloom 后处理", dotColor: "bg-green-500" }
            ]}
            button={{
              text: "查看效果",
              href: "/rendering/refraction"
            }}
          />

          {/* MeshTransmissionMaterial 透射 */}
          <TechCard
            title="玻璃透射效果"
            description="使用 MeshTransmissionMaterial 材质，展示透射、厚度、色差等参数调节的玻璃效果"
            badge={{
              text: "MeshTransmissionMaterial",
              variant: "secondary"
            }}
            icon={{
              Icon: Layers,
              bgColor: "bg-purple-100 dark:bg-purple-900/20",
              iconColor: "text-purple-600 dark:text-purple-400"
            }}
            features={[
              { text: "色差 (chromaticAberration)", dotColor: "bg-green-500" },
              { text: "厚度 (thickness)", dotColor: "bg-green-500" },
              { text: "各向异性 (anisotropy)", dotColor: "bg-green-500" },
              { text: "材质切换功能", dotColor: "bg-green-500" }
            ]}
            button={{
              text: "查看效果",
              href: "/rendering/transmission"
            }}
          />

          {/* 激光内雕 */}
          <TechCard
            title="水晶激光内雕"
            description="使用 MeshTransmissionMaterial 结合点云系统，展示基于真实模型的激光内雕效果"
            badge={{
              text: "MeshTransmissionMaterial",
              variant: "secondary"
            }}
            icon={{
              Icon: Zap,
              bgColor: "bg-amber-100 dark:bg-amber-900/20",
              iconColor: "text-amber-600 dark:text-amber-400"
            }}
            features={[
              { text: "MeshSurfaceSampler 点云", dotColor: "bg-green-500" },
              { text: "Iron Man 模型内雕", dotColor: "bg-green-500" },
              { text: "物理光学衰减", dotColor: "bg-green-500" },
              { text: "延迟阴影初始化", dotColor: "bg-green-500" }
            ]}
            button={{
              text: "查看效果",
              href: "/rendering/laser-engraving"
            }}
          />
        </div>

        {/* 底部信息 */}
        <div className="text-center mt-12">
          <p className="text-sm text-muted-foreground mb-4">
            技术栈：React Three Fiber + @react-three/drei + Leva + PostProcessing
          </p>
          <Button variant="outline" asChild>
            <Link href="/">返回主页</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
